"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("./authenticated.client");
class UserClient extends authenticated_client_1.AuthenticatedClient {
    getMyProjects(fields = ['id', 'name']) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/me/projects?${this.getQueryString({ fields })}`;
            const response = yield this.httpGet(url);
            return response.payload || [];
        });
    }
    getGdprStatus() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/me/gdpr`);
            return response.payload;
        });
    }
    acceptGdprV2() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.httpPut(`/v2/me/gdpr-accept`);
        });
    }
    getMyCustomers() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/me/customers`);
            return response.payload || [];
        });
    }
    getEmailAdministrators() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/me/administrators`);
            return response.payload || [];
        });
    }
    getProjectById(id) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/me/projects/${id}`);
            return response.payload;
        });
    }
    getMyProfile(fields) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/me?${this.getQueryString({ fields })}`);
            return response.payload;
        });
    }
    getMyCurrency() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/me?${this.getQueryString({ fields: ['currency'] })}`);
            const { currency } = response.payload;
            return currency;
        });
    }
    favorite(projectId, entity, entityId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/me/projects/${projectId}/favorite/${entity}/${entityId}`;
            yield this.httpPost(url);
        });
    }
    unfavorite(projectId, entity, entityId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const url = `/v1/me/projects/${projectId}/favorite/${entity}/${entityId}`;
            yield this.httpDelete(url);
        });
    }
    getUserPreferences() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/me/preferences`);
            return response.payload;
        });
    }
    setUserPreferences(settings) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/me/preferences`, Object.assign({}, settings));
            return response.payload;
        });
    }
    getUserProjectPreferences(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/me/projects/${projectId}/preferences`);
            return response.payload;
        });
    }
    getDareboostToken(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/me/projects/${projectId}/tokens/dareboost`);
            return response.payload;
        });
    }
    setUserProjectPreferences(projectId, settings) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPost(`/v1/me/projects/${projectId}/preferences`, Object.assign({}, settings));
            return response.payload;
        });
    }
    getUseRole(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.getUserProjectRole(projectId);
        });
    }
    getUserProjectRole(projectId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/me/projects/${projectId}/role`);
            return response.payload;
        });
    }
    getUserAccountRole(accountId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet(`/v1/me/accounts/${accountId}/role`);
            return response.payload;
        });
    }
    acceptGdpr(acceptedVersion) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/me/gdpr-accept/${acceptedVersion}`);
            return response.payload;
        });
    }
    updateUser(user) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpPut(`/v1/me`, user);
            return response.payload;
        });
    }
    getUserAccountRoles(accountIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet('/v1/me/roles-by-account', {
                params: { ids: accountIds.join(',') },
            });
            return response.payload;
        });
    }
    getUserProjectRoles(projectIds) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet('/v1/me/roles-by-project', {
                params: { ids: projectIds.join(',') },
            });
            return response.payload;
        });
    }
    isAdminOfAnyAccount() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.httpGet('/v1/me/admin-of-any-account');
            return response.payload;
        });
    }
}
exports.UserClient = UserClient;
//# sourceMappingURL=user.client.js.map